module.exports = __webpack_public_path__ + "static/walmart-b06c87cb68c10bef2c236818ee4c1adb.jpg";